import { Core } from "@/core/Core";

export default {

  async getBranchParentConfiguration(context, {branchId}) {
    try {
      return await Core.request("GET", "/api/branches/" + branchId + "/parent_config");
    } catch (e) {
      return null;
    }
  },

  async getBranch(context, {branchId, fallback, augment}) {
    try {
      let query = {
        fallback: fallback ? 1 : 0,
        augment: augment
      };
      return await Core.request("GET", "/api/branches/" + branchId, query);
    } catch (e) {
      return null;
    }
  },

  async getBranchGiftCardTemplates(context, {branchId}) {
    try {
      return await Core.request("GET", "/api/gift_card_templates?branch=" + branchId);
    } catch (e) {
      return null;
    }
  },

  async createBranchGiftCardTemplate(context, {data}) {
    try {
      return await Core.request("POST", "/api/gift_card_templates", data);
    } catch (e) {
      return null;
    }
  },

  async saveGiftCardTemplate(context, {templateId, data}) {
    try {
      return await Core.request("PUT", "/api/gift_card_templates/" + templateId, data);
    } catch (e) {
      return null;
    }
  },

  async getBranchContacts(context, {branchId}) {
    try {
      return await Core.request("GET", "/api/branches/" + branchId + "/contacts");
    } catch (e) {
      return null;
    }
  },

  async saveBranch(context, {branchId, augment, data}) {
    try {
      return await Core.request("PUT","/api/branches/" + branchId + (augment ? `?augment=${augment}` : ''), data);
    } catch (e) {
      return null;
    }
  },

  async saveBranchContacts(context, {branchId, contacts}) {
    try {
      return await Core.request("PUT", "/api/branches/" + branchId + "/contacts", contacts);
    } catch (e) {
      return null;
    }
  },

  async createBranch(context, {augment, data}) {
    try {
      return await Core.request("POST", "/api/branches" + (augment ? `?augment=${augment}` : ''), data)
    } catch (e) {
      return null;
    }
  },

  async getBranchImages(context, {branchId}) {
    try {
      return await Core.request("GET", `/api/branch_images?branch=${branchId}&perPage=-1`);
    } catch (e) {
      return null;
    }
  },

  async getBranchImage(context, {imageId}) {
    try {
      return await Core.request("GET", `/api/branch_images/${imageId}`);
    } catch (e) {
      return null;
    }
  },

  async deleteBranchImage(context, {imageId}) {
    try {
      return await Core.request("DELETE", `/api/branch_images/${imageId}`);
    } catch (e) {
      return null;
    }
  },

  async postBranchImage(context, {data}) {
    try {
      return await Core.request("POST", "/api/branch_images", data);
    } catch (e) {
      return null;
    }
  },

  async putBranchImage(context, {imageId, data}) {
    try {
      return await Core.request("PUT", `/api/branch_images/${imageId}`, data);
    } catch (e) {
      return null;
    }
  },

}
